/**
 * UranIA PA — TanStack Query client (US-009).
 *
 * Default conservativi (analisi §16.5): staleTime 60s per dataset normativi
 * tipo skill catalog; per query con esigenze specifiche (chat-prova SSE,
 * RAG) i singoli use case sovrascrivono `staleTime`/`gcTime`.
 *
 * Retry: 1 tentativo + backoff esponenziale gentile — il Gateway può
 * restituire 503 (kill-switch AgID) e non vogliamo tempestare di retry.
 */

import { QueryClient } from '@tanstack/react-query';

export function createUraniaQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60_000,
        gcTime: 5 * 60_000,
        retry: 1,
        retryDelay: (attempt) => Math.min(1_000 * 2 ** attempt, 15_000),
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}
